import { useTranslation } from 'react-i18next';

import { useViewer } from '@/entities/viewer';
import { PasswordForm, SessionsCard } from '@/features/account';
import { LogoutButton } from '@/features/auth';
import { SettingsShell } from '@/features/settings-shell';
import { LoadingState } from '@/shared/ui';

import styles from './AccountPage.module.css';

/** Settings -> Security: the password and the current session. */
export function SecurityPage() {
  const { t } = useTranslation();
  const viewer = useViewer();
  if (viewer.status !== 'authenticated') return <LoadingState />;
  return (
    <SettingsShell>
      <div className={styles.page}>
        <h1 className={styles.title}>{t('settings.security')}</h1>
        <section className={styles.card} aria-labelledby="password-title">
          <h2 id="password-title" className={styles.sectionTitle}>
            {t('account.password')}
          </h2>
          <p className={styles.note}>{t('account.passwordNote')}</p>
          <PasswordForm />
        </section>
        <section className={styles.card} aria-labelledby="sessions-title">
          <h2 id="sessions-title" className={styles.sectionTitle}>
            {t('account.sessions.title')}
          </h2>
          <SessionsCard />
        </section>
        <section className={styles.card} aria-labelledby="session-title">
          <h2 id="session-title" className={styles.sectionTitle}>
            {t('account.session')}
          </h2>
          <div>
            <LogoutButton />
          </div>
        </section>
      </div>
    </SettingsShell>
  );
}
